import { UserRole } from '../../../Data/UserRolesEnum.ts'
import { useAuth } from '../../../Providers/AuthProvider'

const useCheckUserRole = () => {
  const { authState } = useAuth()

  const isUserHasAccess = (expectedRole: UserRole): boolean => {
    if (!authState.user) {
      return false
    }
    if (authState.user.isOperator) {
      return true
    }
    if (expectedRole === null || expectedRole === undefined) {
      return false
    }
    if (!authState.user.roles || authState.user.roles.length === 0) {
      return false
    }
    return authState.user.roles.some(
      role => role.roleId == UserRole.Admin || role.roleId == expectedRole)
  }

  return { isUserHasAccess }
}

export default useCheckUserRole